import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Measure')
export class Measure {
  @JsonProperty('value', Number, true) value: number = undefined;
  @JsonProperty('unit', String, true) unit: string = undefined;
}
